import React, { useContext, useMemo } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import sendIcon from '../../assets/icons/sendIcon.svg';
import { SocketContext } from '../../contexts/SocketContext';
import { useAppSelector } from '../../hooks/useAppSelector';
import { messengerEvents } from '../../websocket/events';
import Conversation from '../conversation/Conversation';
import { borderInput, useStyles } from './chatContent.styles';

const currentChatSelector = (state: any) => {
  const chats = state.organizerReducer?.noticePages;
  const chatId = state.organizerReducer.conversationId;

  return chats?.find((chat: any) => chat.id === (typeof chatId === 'string' ? parseInt(chatId) : chatId));
};

export const ChatContent = ({ message, setMessage }: any): JSX.Element => {
  const conversationId = useAppSelector((state) => state.organizerReducer.conversationId);
  const currentChat = useAppSelector(currentChatSelector);
  const classes = useStyles();

  useMemo(() => {
    if (conversationId) {
      const value = localStorage.getItem(`chatDrafts${conversationId}`);

      if (value) {
        setMessage(value);
      }
    }
  }, [conversationId, setMessage]);

  const { sendEvent } = useContext(SocketContext);
  const handleClick = () => {
    const data = {
      event: messengerEvents.sendNotice,
      data: {
        message,
        opportunityId: conversationId,
      },
    };

    if (sendEvent && message) {
      const value = localStorage.getItem(`chatDrafts${conversationId}`);
      value && localStorage.setItem(`chatDrafts${conversationId}`, '');
      setMessage('');
      sendEvent(data);
    }
  };

  return (
    <div className={classes.chatContent}>
      <Conversation currentChat={currentChat} />
      {!!currentChat && (
        <TextField
          id="outlined-basic"
          label="Write a message..."
          value={message}
          className={classes.contentInput}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth={true}
          sx={borderInput}
          multiline
          rows={1}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                onClick={handleClick}
              >
                <IconButton>
                  <img src={sendIcon} alt="" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
    </div>
  );
};
